"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _ChevronRight = _interopRequireDefault(require("@insided/shared/icons/ChevronRight"));

var CategoryCardItem = function CategoryCardItem(_ref) {
  var title = _ref.title,
      url = _ref.url,
      metadata = _ref.metadata,
      key = _ref.key;
  return (0, _preact.h)("div", {
    className: "category-card-item",
    key: key
  }, (0, _preact.h)("a", {
    className: "category-card-item-link link",
    href: (0, _absoluteUrlRuntime.resolveUrl)(url)
  }, (0, _preact.h)("div", {
    className: "category-card-item-content"
  }, (0, _preact.h)("div", {
    className: "category-card-item--title"
  }, title), (0, _preact.h)("div", {
    className: "category-card-item--metadata"
  }, metadata)), (0, _preact.h)("div", {
    className: "category-card-item--icon"
  }, (0, _preact.h)(_ChevronRight.default, null))));
};

var _default = CategoryCardItem;
exports.default = _default;